import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_dreambots.png",
      alt: "Estratégias Dream Bots",
    },
    title: "Temos resultados consistentes e podemos provar.",

    // String ou array de strings
    text: "Todos os robôs da Dream Bots passam por um processo rigoroso de testagem antes do lançamento e são ajustados semanalmente para trazer sempre os melhores resultados.",
    testimonial: {
      text: "Sabemos que você só acredita vendo, nós também.",
      author: {
        name: "Gabriel Borgongino e Thiago Duarte, Fundadores da Dream Bots",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Dream Bots",
    heading: "Conheça nossas estratégias!",
    subtitle:
      "Estratégias prontas para você começar a operar como um profissional.",
  },

  cta: {
    title: "Você está pronto?",
    subtitle: "Ative agora mesmo as estratégias Dream Bots!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Dream Bots",
    col1: [
      "Gabriel Borgongino e Thiago Duarte são os sócios-fundadores da Dream Bots, referência em automação de investimentos. A empresa nasceu no ambiente de empreendedorismo da PUC-Rio e foi impulsionada pelos programas de aceleração AWS Activate e Nvidia Inception. Desde então, a expertise da Dream Bots foi aprimorada e ampliada para oferecer aos clientes as melhores tecnologias de automação de investimentos existentes.",
      "Gabriel é Diretor Comercial da Dream Bots, co-responsável por incluir estratégias inovadoras no ecossistema da empresa. Em 2022, foi convidado pela XP Investimentos a ser embaixador da marca através da “aceleradora XP de influenciadores”. Graduado em Comunicação Social pela PUC-Rio, já trabalhou como Ator da TV Globo e no setor de Administração da GloboNews, quando decidiu sair para se dedicar ao empreendedorismo.",
      "Thiago é Diretor de Operações da Dream Bots, especializado na área de automação de processos e inteligência artificial, responsável pela direção dos processos de desenvolvimento e testagem de cada algoritmo. Possui background em Comunicações Militares e graduação em Comunicação Social pela PUC-Rio.",
    ],
    col2: [
      "Impulsionados pela Amazon e Nvidia, a empresa tem como visão tornar robôs de alta tecnologia acessíveis a todos. Seu principal robô, o “Júpiter”, acumula histórico de rentabilidade positiva consistente desde Jul/2021 em conta real.",
      "Em 2023, a Dream Bots leva seu sucesso em automação de investimentos a mais usuários por meio da parceria com a Ontick, para que cada vez mais pessoas possam alcançar bons rendimentos operando de forma automatizada.",
    ],
  },

  stats: {
    title: "Resultados registrados:",
    subtitle: "Números referentes à metodologia BDT desde Janeiro de 2020.",
    data: [
      {
        value: "+96%",
        description: "Das operações com lucro.",
      },
      {
        value: "+1.000%",
        description: "Crescimento bruto acumulado do capital.",
      },
      {
        value: "97%",
        description: "Meses fechados com lucro.",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da Dream Bots?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.savings,
        title: "Comece com pouco",
        description:
          "Robôs com alguns dos menores capitais recomendados da OnTick.",
      },
      {
        icon: iconsSet.click,
        title: "Precisão",
        description:
          "Robôs altamente seletivos e precisos, que entram em operação somente quando há alta probabilidade de acerto.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Algoritmos que respondem rapidamente aos movimentos do mercado.",
      },
      {
        icon: iconsSet.money_off,
        title: "Poucas taxas",
        description:
          "Nossos robôs geram poucos gastos com taxas da bolsa, o que se reverte em mais lucro líquido para o assinante.",
      },
      {
        icon: iconsSet.yoga,
        title: "Fácil de usar",
        description: "Ideal até para iniciantes no mundo dos investimentos.",
      },
      {
        icon: iconsSet.monitoring,
        title: "Monitoramento diário dos desenvolvedores",
        description: "Você estará em boas mãos.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "A Dream Bots me deu a oportunidade de ter uma rentabilidade melhor mesmo com o pouco tempo que eu tenho disponível. Os robôs são atualizados sempre, os algoritmos parecem ser muito bem elaborados e eles conseguiram me explicar muito bem o funcionamento deles. Parabéns ao Gabriel e ao Thiago pelos excelentes resultados!",
      author: "Leandro Albuquerque",
      job: "Empresário",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Eu já vinha procurando uma maneira de investir melhor e a Dream Bots me ajudou bastante nisso. Os robôs são confiáveis e têm me dado retornos muito bons. Obrigada, pessoal! Muito rendimento nesses últimos 6 meses. Gratidão!!",
      author: "Wenia Valladares",
      job: "Enfermeira",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
